import React from 'react'
import style from './TableOptions.module.css'
import { Link } from 'react-router-dom'
import { Select, SelectProps } from 'antd'
import { Progress, Priority, Status } from 'types'
import axiosClient from 'axios-client'
import { useStateContext } from 'context/ContextProvider'

// Get enums
//const platforms = Object.values(Platform);
const progress = Object.values(Progress)
const priority = Object.values(Priority)
const status = Object.values(Status)

interface TableOptionsProps {
  selectedRows: React.Key[]
  type: 'accounts' | 'clients' | 'users' | 'tasks'
  updateObject?: (field: string, status: string) => void
}

const progressOptions: SelectProps['options'] = progress.map(label => ({
  label: label,
  value: label,
}))

const priorityOptions: SelectProps['options'] = priority.map(label => ({
  label: label,
  value: label,
}))

const statusOptions: SelectProps['options'] = status.map(label => ({
  label: label,
  value: label,
}))

const TableOptions: React.FC<TableOptionsProps> = props => {
  const { selectedRows, type } = props

  // Early return if no rows are selected
  if (selectedRows.length === 0) return <></>

  // *** Bulk Update Handlers ***
  const handleUpdateProgress = (newStatus: string) => {
    axiosClient
      .patch(`/${type}/bulkprogress`, {
        progress: newStatus,
        ids: selectedRows,
      })
      .then(() => {
        if (props.updateObject) props.updateObject('progress', newStatus)
      })
  }

  const handleUpdatePriority = (newStatus: string) => {
    axiosClient
      .patch(`/${type}/bulkpriority`, {
        priority: newStatus,
        ids: selectedRows,
      })
      .then(() => {
        if (props.updateObject) props.updateObject('priority', newStatus)
      })
  }

  const handleUpdateStatus = (newStatus: string) => {
    axiosClient
      .patch(`/${type}/bulkstatus`, {
        status: newStatus,
        ids: selectedRows,
      })
      .then(() => {
        if (props.updateObject) props.updateObject('status', newStatus)
      })
  }

  return (
    <div className={style.optionTable}>
      {/* Display selected row count */}
      <div className={style.selectedRows}>{selectedRows.length} items selected</div>

      {/* Single Row Actions (View/Edit) - Conditionally rendered */}
      {selectedRows.length === 1 && (
        <>
          {!(type === 'users') && (
            <Link
              className={style.view}
              to={`/${type}/view/` + selectedRows[0]}
            >
              View
            </Link>
          )}
          <Link
            className={style.edit}
            to={`/${type}/` + selectedRows[0]}
          >
            Edit
          </Link>
        </>
      )}

      {/* Bulk Status Update Select */}
      <Select
        className={style.optionSelect}
        defaultValue={'Change Status'}
        options={type === 'tasks' ? progressOptions : statusOptions}
        onChange={type === 'tasks' ? handleUpdateProgress : handleUpdateStatus}
      />

      {/* Bulk Priority Update Select (Tasks Only) */}
      {type === 'tasks' && (
        <Select
          className={style.optionSelect}
          defaultValue={'Change Priority'}
          options={priorityOptions}
          onChange={handleUpdatePriority}
        />
      )}
    </div>
  )
}

export default TableOptions
